import { useEffect, useState } from 'react';

const useComponentSequencer = ( trigger, input ) => {
  let [prev, setPrev] = useState('');
  let [animate, setAnimate] = useState(false);
  let [render, setRender] = useState(false);
  let seg = input;
  // console.log('seg: ', seg)
  useEffect(() => {
    if (seg === trigger && prev !== trigger) {
      // console.log('--->>entering ' + thisPage)
      setRender(true);
      setAnimate(true);
      setPrev(trigger);
    }
    if (seg !== trigger && prev === trigger) {
      setAnimate(false);
      setPrev('');
      // console.log('<<---exiting ' + thisPage)
    }
  }, [seg]);
  return { animate, setAnimate, render, setRender }
}
export default useComponentSequencer;